import { createConnectQueryKey } from '@connectrpc/connect-query'
import {
  listWeatherForecastPoints,
  updateWeatherForecastPoints,
} from '@ebalance/proto/bffuser/v1/weather_forecast_point_service-WeatherForecastPointService_connectquery'

import {
  type InvalidatingMutationResultFor,
  useInvalidatingMutation,
} from '~/hooks/useInvalidatingMutation'

/**
 * 地点を選んだエリア 1 件ずつを Update で送信する (AC-WFP-003/004)。
 * 成功時に listWeatherForecastPoints cache を invalidate する。
 */
export function useUpdateWeatherForecastPoints(): InvalidatingMutationResultFor<
  typeof updateWeatherForecastPoints
> {
  return useInvalidatingMutation(updateWeatherForecastPoints, [
    createConnectQueryKey({
      schema: listWeatherForecastPoints,
      cardinality: 'finite',
    }),
  ])
}
